import { getSingleEducationalMaterialByQueryParamsSchema } from '@/api/educationalMaterial'
import { GlobalErrorPage } from '@/components/ui/errors'
import { createFileRoute, Outlet } from '@tanstack/react-router'

export const Route = createFileRoute('/educational/material/')({
  component: Outlet,
  errorComponent: GlobalErrorPage,
  validateSearch: getSingleEducationalMaterialByQueryParamsSchema,
})
